<div class="h-100 d-flex app w-100 overflow-hidden">
    <header class="absolute sm:pl-10x h-auto md:h-40 m-auto w-100 sm:content-start" *ngIf="showSidebar">
        <gt-company-logo [loginChallenge]="loginChallenge"
                         [logoType]="clientLogo"
                         [domainName]="domainName">
        </gt-company-logo>
    </header>
    <div class="container-fluid d-flex flex-column px-0">
        <alert type="warning" *ngIf="maintenanceMsg">{{maintenanceMsg}}</alert>
        <main class="d-flex flex-grow-1 h-100 w-100 md:mt-0 sm:mt-55 mt-50">
            <div class="container-fluid align-self-center">
                <ng-container>
                    <section class="row flex-nowrap min-h-section">
                        <div class="article m-auto mt-0 sm:mt-auto sm:pl-15x sm:self-center md:pt-0">
                            <router-outlet></router-outlet>
                        </div>
                        <div class="article hidden items-center sm:flex" *ngIf="showSidebar">
                            <ng-container *ngIf="showSidebar">
                                <info-slider [loginChallenge]="loginChallenge" [domain]="domainName"></info-slider>
                            </ng-container>
                        </div>
                    </section>
                </ng-container>
            </div>
        </main>
        <div class="footer hidden sm:block sm:p-0 sm:w-full sm:fixed sm:h-auto sm:bottom-0"  *ngIf="showSidebar">
            <app-footer [loginChallenge]="loginChallenge" [domainName]="domainName"></app-footer>
        </div>
    </div>
</div>
<gt-toast [position]="position"></gt-toast>
